import React, { useState, useEffect } from "react";

const AddStudentDialog = ({
  students,
  displayedStudentName,
  setDisplayedStudentName,
  selectedStudentToAdd,
  setSelectedStudentToAdd,
  handleAddStudentToCell,
  closeDialog,
  targetDay,
  targetHour,
  targetCoach,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  // Check if selected student already has assignments
  useEffect(() => {
    if (selectedStudentToAdd) {
      const student = students.find(s => s._id === selectedStudentToAdd);

      console.log('DEBUG AddStudentDialog:');
      console.log('  Student:', student?.firstName, student?.lastName);
      console.log('  Target slot:', targetDay, targetHour);
      console.log('  Student assignments:', student?.assignments);

      if (student && student.assignments && student.assignments.length > 0) {
        // Normalize coach IDs (treat null, undefined, "" as the same)
        const normalizeCoach = (coach) => {
          if (coach === null || coach === undefined || coach === "") {
            return null;
          }
          return String(coach);
        };

        // Check if student is already assigned to this EXACT slot (day + hour + coach)
        const alreadyAtThisSlot = student.assignments.some(
          a => {
            console.log('  Comparing:', a.day, a.hour, a.coach, 'with', targetDay, targetHour, targetCoach);
            // Must match day, hour, AND coach to be a true duplicate
            return a.day === targetDay &&
                   a.hour === targetHour &&
                   normalizeCoach(a.coach) === normalizeCoach(targetCoach);
          }
        );

        console.log('  Already at this exact slot (day+hour+coach)?', alreadyAtThisSlot);

        if (alreadyAtThisSlot) {
          // Student already at this EXACT slot with this coach - silently cancel and reset
          setSelectedStudentToAdd("");
          setDisplayedStudentName("");
          return;
        }

        // Has other assignments (different slot or different coach) - show confirmation
        setSelectedStudent(student);
        setShowConfirmation(true);
      }
    }
  }, [selectedStudentToAdd, students, targetDay, targetHour, targetCoach]);

  const handleConfirmMove = () => {
    handleAddStudentToCell("move"); // Replace all assignments
    setShowConfirmation(false);
    setSelectedStudent(null);
  };

  const handleConfirmAdd = () => {
    handleAddStudentToCell("add"); // Add to existing assignments
    setShowConfirmation(false);
    setSelectedStudent(null);
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
    setSelectedStudent(null);
    setSelectedStudentToAdd("");
    setDisplayedStudentName("");
  };

  // Confirmation dialog (shown when student already has assignments)
  if (showConfirmation && selectedStudent) {
    return (
      <div className="modal-overlay">
        <div className="add-student-dialog confirmation-dialog">
          <h3>Schüler bereits zugewiesen</h3>

          <p><strong>{selectedStudent.firstName} {selectedStudent.lastName}</strong> ist bereits zugewiesen:</p>

          <ul className="existing-assignments">
            {selectedStudent.assignments.map((assignment, idx) => (
              <li key={idx}>
                📅 {assignment.day} {assignment.hour}:00
              </li>
            ))}
          </ul>

          <p>Möchten Sie den Schüler <strong>verschieben</strong> oder <strong>hinzufügen</strong>?</p>

          <div className="confirmation-info">
            <div className="info-box">
              <strong>Verschieben:</strong> Entfernt alle bisherigen Zuweisungen und weist nur {targetDay} {targetHour}:00 zu.
            </div>
            <div className="info-box">
              <strong>Hinzufügen:</strong> Behält bisherige Zuweisungen und fügt {targetDay} {targetHour}:00 hinzu.
            </div>
          </div>

          <div className="dialog-buttons">
            <button onClick={handleConfirmMove} className="btn-move">
              Verschieben
            </button>
            <button onClick={handleConfirmAdd} className="btn-add">
              Hinzufügen
            </button>
            <button onClick={handleCancelConfirmation} className="btn-cancel">
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Normal student selection dialog
  return (
    <div className="modal-overlay">
      <div className="add-student-dialog">
        <h3>Schüler hinzufügen</h3>

        {/* Eingabefeld für Filter */}
        <input
          type="text"
          placeholder="Name eingeben..."
          value={displayedStudentName}
          onChange={(e) => {
            setSelectedStudentToAdd(""); // Setzt die ID zurück
            setDisplayedStudentName(e.target.value); // Aktualisiert den Namen
          }}
        />

        <ul className="student-grid">
          {students
            .filter((student) =>
              `${student.firstName} ${student.lastName}`
                .toLowerCase()
                .includes(displayedStudentName.toLowerCase())
            )
            .map((student) => {
              // Show indicator if student has assignments
              const hasAssignments = student.assignments && student.assignments.length > 0;

              return (
                <li key={student._id}>
                  <button
                    onClick={() => {
                      setSelectedStudentToAdd(student._id); // Speichert die ID
                      setDisplayedStudentName(
                        `${student.firstName} ${student.lastName}`
                      );
                    }}
                  >
                    {student.firstName} {student.lastName}
                    {hasAssignments && <span className="assignment-badge">({student.assignments.length}×)</span>}
                  </button>
                </li>
              );
            })}
        </ul>

        <div className="dialog-buttons">
          <button onClick={() => handleAddStudentToCell("add")}>Hinzufügen</button>
          <button onClick={closeDialog}>Abbrechen</button>
        </div>
      </div>
    </div>
  );
};

export default AddStudentDialog;
